module.exports = __webpack_public_path__ + "static/media/logo2.c629bd4e.png";